import { getSessionPortal, isAuth } from "./Auth";
import { AUTH_CONTEXT_TYPE } from "./authPortal";
import { getCompanyPortalHomeRoute, isSuperAdmin } from "./Permissions";
import { ROUTE_PATHS } from "./RoutesPaths";

const COMPANY_DEFAULT_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "staging.admin.proline.sa",
  "app.staging.yoram.sa",
]);

export function isCompanyDefaultHost(
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) {
  if (!hostname) return false;
  return COMPANY_DEFAULT_HOSTS.has(hostname.toLowerCase());
}

/** Root and fallback redirect — company portal on localhost and staging. */
export function getDefaultAppEntryPath() {
  if (!isCompanyDefaultHost()) {
    return ROUTE_PATHS.events;
  }

  if (isAuth()) {
    const sessionPortal = getSessionPortal();
    if (sessionPortal === AUTH_CONTEXT_TYPE.COMPANY) {
      return getCompanyPortalHomeRoute();
    }
    if (sessionPortal === AUTH_CONTEXT_TYPE.CLIENT) {
      return ROUTE_PATHS.clientPortalEvents;
    }
    if (sessionPortal === AUTH_CONTEXT_TYPE.ADMIN) {
      return isSuperAdmin() ? ROUTE_PATHS.adminDashboard : ROUTE_PATHS.events;
    }
  }

  return ROUTE_PATHS.companyLogin;
}
